import { MediaTypes } from "@coworker/app/src/components/RoomSettings/constants";
import { getMediaTypeText } from "@coworker/app/src/components/RoomSettings/tools";
import { MediasAndArticleCountResponse } from "@coworker/app/src/components/RoomSettings/types/media";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import useTranslation from "../../../../../../packages/locales/translations/util/useTranslation";

interface MediaPlacementsListViewProps {
  groupedMediasByType: Record<string, MediasAndArticleCountResponse[]>;
  showCheckBox?: boolean;
}

export const MediaPlacementsListView = ({
  groupedMediasByType,
  showCheckBox = false,
}: MediaPlacementsListViewProps) => {
  const { t } = useTranslation();
  return (
    <>
      {Object.entries(groupedMediasByType).map(
        ([mediaType, mediaAndArticleCounts]) => (
          <FixaListView key={mediaType} id={`media-type-${mediaType}`}>
            <FixaListViewItem
              size="small"
              description={getMediaTypeText(mediaType as MediaTypes)}
              key={`${mediaType}-header`}
            />
            {mediaAndArticleCounts.map((mediaAndArticleCount) => (
              <FixaListViewItem
                key={`${mediaAndArticleCount.mediaId}-${mediaAndArticleCount.groupId}-${mediaAndArticleCount.articleId}`}
                size="medium"
                title={
                  <FixaText textStyle="Heading.S">
                    {mediaType === MediaTypes.ROOM &&
                    mediaAndArticleCount.parentMediaName
                      ? mediaAndArticleCount.parentMediaName
                      : mediaAndArticleCount.name}
                  </FixaText>
                }
                description={
                  <FixaText textStyle="Body.M">
                    {mediaType === MediaTypes.ROOM &&
                    mediaAndArticleCount.parentMediaName
                      ? `${mediaAndArticleCount.name}${mediaAndArticleCount.groupName ? ` > ${mediaAndArticleCount.groupName}` : ""}`
                      : mediaAndArticleCount.groupName}
                  </FixaText>
                }
                quantityLabel={
                  <FixaText textStyle="Body.M">
                    {t("piecesCountString", {
                      count: mediaAndArticleCount.nbrArticles,
                    })}
                  </FixaText>
                }
                control={showCheckBox ? "checkbox" : undefined}
              ></FixaListViewItem>
            ))}
          </FixaListView>
        )
      )}
    </>
  );
};
